import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import backBtn from "../../assets/images/backBtn.svg";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import { getItem } from "../../common/localStorage";
import welcomebg from "../../assets/images/welcomebg.png";
import { useTranslation } from "react-i18next";
import {
  GUEST_ENROLLMENT_PATHS,
  guestEnrollmentPathFromStep,
} from "../../common/guestEnrollmentFlow";
import { useDispatch, useSelector } from "react-redux";
// import { guestUserLogout } from "../../common/guestUserLogout";
// import logoutMobile from "../../assets/images/logoutMobile.svg";
import { STATUS_CODE } from "../../common";
import { stepperNextStepHandler, stepperNextStepSliceAction } from "../../redux/action/guestUserAction/stepperNextStep";
import EducationalContentHeader from "./EducationalContentHeader";
import { getWelcomeHandler } from "../../redux/action/guestUserAction/getWelcome";
import productCodeIcon from "../../assets/images/tag.svg";
import NoDataAvailableState from "./NoDataAvailableState";
const Welcome = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getCurrentStepsSelector = useSelector((state) => state?.stepperNextStep);
  const { data: getWelcomeScreenData, isLoading: isWelcomeScreenLoading } = useSelector((state) => state?.getWelcomeScreen);
  const welcomeData = getWelcomeScreenData?.data || {};
  const hasWelcomeData = welcomeData && Object.keys(welcomeData).length > 0;
  const getLoginResponseData = getItem("guestLoginResponse");
  // const firstNameRaw = getItem("firstName") ?? "John";
  // const lastNameRaw = getItem("lastName") ?? "Cooper";
  // const firstName =
  //   firstNameRaw === null || firstNameRaw === undefined
  //     ? "John"
  //     : String(firstNameRaw);
  // const lastName =
  //   lastNameRaw === null || lastNameRaw === undefined
  //     ? "Cooper"
  //     : String(lastNameRaw);
  // const fullName = [firstName, lastName].filter(Boolean).join(" ");

  const handleBack = () => {
    // Keep behavior consistent with other screens: return to previous page if possible.
    navigate("/guest-user/terms-of-use-and-condition");
  };
  // const handleLogout = () => guestUserLogout(dispatch, navigate);

  const handleContinue = () => {
    dispatch(stepperNextStepHandler({
      currentStep: "WELCOME",
    }))
  };

  useEffect(() => {
    const payload = getCurrentStepsSelector?.data;
    if (payload?.statusCode === STATUS_CODE.OK) {
      const nextPath = guestEnrollmentPathFromStep(payload?.data?.nextStep);
      navigate(nextPath || GUEST_ENROLLMENT_PATHS.educational, {
        state: { guestEducationalBackTo: GUEST_ENROLLMENT_PATHS.welcome },
      });
      dispatch(stepperNextStepSliceAction.stepperNextStepSliceReset());
    }
  }, [getCurrentStepsSelector, navigate]);

  useEffect(() => {
    dispatch(getWelcomeHandler({
      ssn: getLoginResponseData?.ssn,
      dob: getLoginResponseData?.dateOfBirth,
      deviceType: "ANDROID",
      deviceId: "device123",
      modelName: "Pixel 7",
      deviceName: "My Phone",
      brand: "Google",
      fcmToken: "sample-fcm-token",
    }));
  }, []);

  return (
    <>
      <EducationalContentHeader
        backBtnSrc={backBtn}
        backBtnMobileSrc={backBtnMobile}
        onBack={handleBack}
        title={t("Welcome Screen")}
        hideNavigation
        hideBackButton
      >
        {isWelcomeScreenLoading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
          </div>
        )}

        {!hasWelcomeData && !isWelcomeScreenLoading && (

          <NoDataAvailableState subtitle="No welcome screen data found" />
        )}

        {hasWelcomeData && (
          <div className="container marginTop80 noMobileMargin">
            <div className="mx-600 mx-auto">
              <div className="welcomeBanner text-center mb-40">
                <img src={welcomebg} alt="" className="welcomeBannerImg" />
                <img src={welcomebg} alt="" className="welcomeBannerImg2" />
                <div className="fs-20 fw-700 text-white mb-12 tgb">
                  {t("Hello")}, {welcomeData?.userName || "-"}
                </div>
                <div className="fs-16 text-white mb-8" style={{ opacity: 0.8 }}>
                  {welcomeData?.welcomeText || "-"}
                </div>
                <div className="fs-16 fw-500 mt-8 productheightlight">
                  <img src={productCodeIcon} alt="productCodeIcon" />
                  {welcomeData?.productCode || "-"}
                </div>
              </div>

              <div className="paycheck-block mb-40">
                <div className="fs-20 fw-700 colorblur tgb mb-10">
                  {welcomeData?.aboutTitle || "-"}
                </div>

                <div className="fs-16 colorblur lh-20">
                  {welcomeData?.aboutDescription || "-"}
                </div>
                <div className="divider20" />
                <div className="d-flex justify-between gap-18 mt-18">
                  <div style={{ flex: 1 }}>
                    <div className="fs-16 colorblur mb-8">
                      {welcomeData?.yearsOfExperienceLabel || "-"}
                    </div>
                    <div className="fs-18 fw-600 colorblur">
                      {welcomeData?.yearsOfExperienceValue || "-"}
                    </div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="fs-16 colorblur mb-8">
                      {welcomeData?.customersServedLabel || "-"}
                    </div>
                    <div className="fs-18 fw-600 colorblur">
                      {welcomeData?.customersServedValue || "-"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="paycheck-block mb-50">
                <div className="fs-20 mb-10 fw-700 colorblur tgb">
                  {welcomeData?.productInformationTitle || "-"}
                </div>

                <div className="fs-16 colorblur mb-20">
                  {welcomeData?.productInformationDescription || "-"}
                </div>

                <ul className="benefits-list fs-16 colorblur pl-24">
                  {welcomeData?.benefitList?.length > 0 && (
                    welcomeData?.benefitList?.map((benefit, index) => (
                      <li key={`${benefit?.title}-${index}`}>
                        <span className="fw-500 colorblur gotham-medium fs-16" >{benefit?.title}</span>
                        {benefit?.description && (
                          <ul className="mt-8" style={{ paddingLeft: 15 }}>
                            <li className="fw-400 colorblur fs-14">{benefit.description}</li>
                          </ul>
                        )}
                      </li>
                    ))
                  )}
                </ul>
              </div>

              <button
                className="primaryButton w-100 mt-30 cursor-pointer fs-18 mb-20"
                onClick={() => handleContinue()}
              >
                {t("Continue")}
              </button>
            </div>
          </div>
        )}
      </EducationalContentHeader>
    </>
  );
};

export default Welcome;
